//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHoverBg: false,
            puzzles: [
                {
                    image: 'w1d5geologist.png',
                    x: 500,
                    y: 520,
                    width: 177,
                    height: 198,
                    correctDropAreaIndex: 2,
                    dropAreaIndex: -1
                },
                {
                    image: 'w1d5engineer.png',
                    x: 700,
                    y: 520,
                    width: 68,
                    height: 196,
                    correctDropAreaIndex: 1,
                    dropAreaIndex: -1
                },
                {
                    image: 'w1d5chemist.png',
                    x: 800,
                    y: 520,
                    width: 177,
                    height: 127,
                    correctDropAreaIndex: 0,
                    dropAreaIndex: -1
                }
            ],
            dropAreas: [
                {
                    xMin: 394,
                    xMax: 598,
                    yMin: 144,
                    yMax: 474
                },
                {
                    xMin: 621,
                    xMax: 824,
                    yMin: 144,
                    yMax: 474
                },
                {
                    xMin: 842,
                    xMax: 1045,
                    yMin: 144,
                    yMax: 474
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.puzzles.filter(puzzle => puzzle.correctDropAreaIndex === puzzle.dropAreaIndex).length;

            return this.$game.getDragDropResult(numCorrect, this.puzzles.length - numCorrect);
        }
    },

    methods: {
        dragend (puzzle, { x, y }) {
            this.showHoverBg = false;

            puzzle.x = x;
            puzzle.y = y;
            puzzle.dropAreaIndex = this.dropAreas.findIndex((area, index) =>
                puzzle.x >= area.xMin - puzzle.width / 2 &&
                puzzle.x <= area.xMax - puzzle.width / 2 &&
                puzzle.y >= area.yMin - puzzle.height / 2 &&
                puzzle.y <= area.yMax - puzzle.height / 2
            );

            if (puzzle.dropAreaIndex !== -1) {
                this.$nextTick(() => {
                    puzzle.x = this.dropAreas[puzzle.dropAreaIndex].xMin + 100 - puzzle.width / 2;
                    puzzle.y = 250;
                });
            }
        }
    }
};
